import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import './index.css';
import Home from './components/Home'
import RiderRegistration from './components/RiderRegistration'
import CommuterRegistration from './components/CommuterRegistration'
import PBar from './components/ProgressBar'
import * as serviceWorker from './serviceWorker';
import NewVehicleAddition from './components/NewVehicleAddition';
import PrivateRoute from './components/PrivateRoute'

const Routing = (
    <Router>
        <Switch>
            <Route exact path="/" component={Home} />
            <PrivateRoute path="/rider-registration" component={RiderRegistration} />
            <PrivateRoute path="/progress-bar" component={PBar} />
            <PrivateRoute path="/commuter-registration" component={CommuterRegistration} />
            <PrivateRoute path="/add-vehicle" component={NewVehicleAddition} />
            <Route path="**" render={() => <Redirect to={{ pathname: "/" }} />} />
        </Switch>
    </Router>
)

ReactDOM.render(Routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
